import { findUsedVendorsForDeclaration } from "./findUsedVendorsForDeclaration.js";
/**
 * Get a list of used declarations for e.g. `purposes`. It can also return an
 * empty array if the given declaration does not have any items/vendors.
 */ function findUsedDeclarations(declaration, gvl, model, filterBy, sorted) {
    if (sorted === void 0) sorted = false;
    const { [declaration]: declarations } = gvl;
    const declarationValues = Object.values(declarations);
    // Collect a map of `id` => `length of vendors` so we can hide the complete declaration if no vendor is available
    const lengthMap = declarationValues.reduce((map, param)=>{
        let { id } = param;
        map[id] = findUsedVendorsForDeclaration(gvl, model, id, declaration, filterBy === "legInt", sorted).length;
        return map;
    }, {});
    return declarationValues.filter((param)=>{
        let { id } = param;
        return lengthMap[id];
    });
}
export { findUsedDeclarations };
